<template>
  <div class="memberCenter_wrap EnterpriseInform">
    <div class="nav_pos mb_nav_pos">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <router-link to="/MemberCenter">首页</router-link>
        </el-breadcrumb-item>
        <el-breadcrumb-item>我的详细信息</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="back_btn" @click="back">
        返回
        <img src="@/assets/img/icon_return.png" alt />
      </div>
    </div>
    <div class="content_wrap">
      <el-tabs v-model="activeName" class="member_tabs">
        <el-tab-pane label="基本信息" name="first">
          <div class="change_inform">
            <div class="title">基本信息</div>
            <el-form :inline="true" :model="formInline" class="form_table1">
              <el-form-item label="供应商名称" class="allLine">{{ formInline.SupplierName }}</el-form-item>
              <el-form-item label="统一社会信用代码" class="allLine">{{ formInline.SocialCreditCode }}</el-form-item>
              <el-form-item label="公司类型">{{ formInline.CompanyType }}</el-form-item>
              <el-form-item label="纳税人类型">{{ formInline.TaxPayerSize }}</el-form-item>
              <el-form-item label="纳税人信用等级">{{ formInline.TaxPayerLevel }}</el-form-item>
              <el-form-item label="供应商类型" class="wrap_style">
                <div v-for="(item, index) in formInline.SupplierType" :key="index" style="padding-bottom: 10px">{{ item }}</div>
              </el-form-item>
              <el-form-item label="主要产品或服务">{{ formInline.MajorProject }}</el-form-item>
              <el-form-item label="法定代表人">{{ formInline.LegalRepresentative }}</el-form-item>
              <el-form-item label="成立日期">{{ formInline.SetupDate }}</el-form-item>
              <el-form-item label="注册资金（万元）">{{ formInline.RegisteredCapital }}</el-form-item>
              <el-form-item label="实缴资金（万元）">{{ formInline.PaidInCapital }}</el-form-item>
              <el-form-item label="注册地址">{{ formInline.RegisteredAddress }}</el-form-item>
              <el-form-item label="办公地址">{{ formInline.OfficeAddress }}</el-form-item>
              <el-form-item label="营业期限">{{ formInline.BusinessTermDate }}</el-form-item>

              <el-form-item label="经营范围" class="allLine">{{ formInline.BusinessScope }}</el-form-item>
              <el-form-item label="资产总计（万元）">{{ formInline.TotalAssets }}</el-form-item>
              <el-form-item label="上年营业收入">{{ formInline.LastYearTotalSales }}</el-form-item>
              <el-form-item label="售后服务承诺和措施" class="allLine">{{ formInline.AfterSalesService }}</el-form-item>
              <el-form-item label="公司简介" class="allLine">{{ formInline.CompanyProfile }}</el-form-item>
              <el-form-item label="公司网址" class="allLine">{{ formInline.Website }}</el-form-item>
              <el-form-item label="关联公司">{{ formInline.SupplierRelatedCompany }}</el-form-item>
              <el-form-item></el-form-item>
            </el-form>
          </div>

          <div class="change_inform">
            <div class="title">相关附件</div>
            <table class="record_table">
              <tbody>
                <tr>
                  <th width="300px">材料名称</th>
                  <th>附件</th>
                </tr>
                <tr v-for="(item, index) in fileList2" :key="index">
                  <td>{{ item.FileTypeName }}</td>
                  <td class="link" @click="download(item.FileId, item.Remark, item.FileName)">{{ item.FileName }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="change_inform">
            <div class="title">公司物业及人员情况</div>
            <el-form :inline="true" :model="formInline" class="form_table1">
              <el-form-item prop="OwnArea" label="自有物业所有权面积(平方)">{{ formInline.OwnArea }}</el-form-item>
              <el-form-item prop="LeasingArea" label="租赁物业所有权面积(平方)">{{ formInline.LeasingArea }}</el-form-item>
              <el-form-item prop="TotalCount" label="公司总人数">{{ formInline.TotalCount }}</el-form-item>
              <el-form-item prop="SocialInsuranceCount" label="社保人数">{{ formInline.SocialInsuranceCount }}</el-form-item>
              <el-form-item label="相关附件" class="allLine" prop="WinSupplierList">
                <table class="record_table">
                  <tbody>
                    <tr>
                      <th width="300px">材料名称</th>
                      <th>附件</th>
                    </tr>
                    <tr v-for="(item, index) in fileList3" :key="index">
                      <td>{{ item.FileTypeName }}</td>
                      <td class="link" @click="download(item.FileId, item.Remark, item.FileName)">{{ item.FileName }}</td>
                    </tr>
                  </tbody>
                </table>
              </el-form-item>
            </el-form>
          </div>

          <div class="change_inform">
            <div class="title">联系人信息</div>
            <el-form :inline="true" :model="formInline" class="form_table1">
              <el-form-item prop="IntroductionSource" label="引入来源">{{ formInline.IntroductionSource }}</el-form-item>
              <el-form-item prop="ReferrerName" label="推荐人">{{ formInline.ReferrerName }}</el-form-item>
              <el-form-item label="联系人信息" class="allLine" prop="WinSupplierList">
                <table class="record_table">
                  <tbody>
                    <tr>
                      <th>备注</th>
                      <th>姓名</th>
                      <th>职位</th>
                      <th>手机号码</th>
                      <th>电子邮箱</th>
                    </tr>
                    <tr v-for="(item, index) in formInline.ContactList" :key="index">
                      <td>{{ item.IsPrimary }}</td>
                      <td>{{ item.ContactName }}</td>
                      <td>{{ item.Duty }}</td>
                      <td>{{ item.Mobile }}</td>
                      <td>{{ item.Email }}</td>
                    </tr>
                  </tbody>
                </table>
              </el-form-item>
            </el-form>
          </div>
          <div class="change_inform">
            <div class="title">银行收款信息</div>
            <el-form :inline="true" :model="formInline" class="form_table1">
              <el-form-item prop="BankAccountName" label="开户名">{{ formInline.BankAccountName }}</el-form-item>
              <el-form-item prop="BankAccount" label="银行账户">{{ formInline.BankAccount }}</el-form-item>
              <el-form-item prop="BankApprovalNumber" label="联行号">{{ formInline.BankApprovalNumber }}</el-form-item>
              <el-form-item prop="Bank" label=" 开户名称">{{ formInline.Bank }}</el-form-item>
              <el-form-item label="相关附件" class="allLine" prop="WinSupplierList">
                <table class="record_table">
                  <tbody>
                    <tr>
                      <th width="300px">材料名称</th>
                      <th>附件</th>
                    </tr>
                    <tr v-for="(item, index) in fileList4" :key="index">
                      <td>{{ item.FileTypeName }}</td>
                      <td class="link" @click="download(item.FileId, item.Remark, item.FileName)">{{ item.FileName }}</td>
                    </tr>
                  </tbody>
                </table>
              </el-form-item>
            </el-form>
          </div>
          <div class="change_inform" v-if="formInline.MainBusinesseList.length > 0">
            <div class="title">主营业务情况（近三年）</div>
            <el-table :data="formInline.MainBusinesseList" v-if="formInline.MainBusinesseList.length > 0">
              <el-table-column prop="Years" label="年份" align="center"></el-table-column>
              <el-table-column prop="MainBusiness" label="主要业务" align="center"></el-table-column>
              <el-table-column prop="ProductName" label="具体产品/服务" align="center"></el-table-column>
              <el-table-column prop="Brand" label="品牌" align="center"></el-table-column>
              <el-table-column prop="YearTotalSales" label="年营业额（万元）" align="center"></el-table-column>
              <el-table-column prop="MainCustome" label="主要客户" align="center"></el-table-column>
              <el-table-column prop="CompanyCompetitor" label="主要竞争对手" align="center"></el-table-column>
              <el-table-column prop="BrandCompetitor" label="品牌竞争对手" align="center"></el-table-column>
            </el-table>
          </div>
          <div class="change_inform" v-if="formInline.CustomDistributionList.length > 0">
            <div class="title">客户分布情况（近三年）</div>
            <el-table :data="formInline.CustomDistributionList" v-if="formInline.CustomDistributionList.length > 0">
              <el-table-column prop="Years" label="年份" align="center"></el-table-column>
              <el-table-column prop="IndustrialCustomers" label="客户所处行业" align="center"></el-table-column>
              <el-table-column prop="Representative" label="客户代表" align="center"></el-table-column>
              <el-table-column prop="TotalSales" label="销售额（万元）" align="center"></el-table-column>
              <el-table-column prop="TotalSales" label="备注" align="center"></el-table-column>
            </el-table>
          </div>
          <div class="change_inform" v-if="formInline.FinanceStatuseList.length > 0">
            <div class="title">财务信息</div>
            <el-table :data="formInline.FinanceStatuseList" v-if="formInline.FinanceStatuseList.length > 0">
              <el-table-column prop="Years" label="年份" align="center"></el-table-column>
              <el-table-column prop="TotalAssets" label="资产总计（万元）" align="center"></el-table-column>
              <el-table-column prop="OperatingIncome" label="营业收入（万元）" align="center"></el-table-column>
              <el-table-column prop="NetProfit" label="净利润（万元）" align="center"></el-table-column>
              <el-table-column prop="OperatingNetCash" label="经营性净现金流（万元）" align="center"></el-table-column>
              <el-table-column prop="AssetLoadRate" label="资产负债率" align="center"></el-table-column>
            </el-table>
          </div>
          <div class="change_inform">
            <div class="title">供应商资质</div>
            <table class="record_table">
              <tbody>
                <tr>
                  <th>基础资质类别</th>
                  <th>资质有效期</th>
                  <th>资质状态</th>
                  <th>附件</th>
                </tr>
                <tr v-for="(item, index) in formInline.QualificationList" :key="index">
                  <td>{{ item.QualificationTypeName }}</td>
                  <td>{{ item.ServiceLifeDate }}</td>
                  <td>{{ item.QualificationStatus }}</td>
                  <td class="link" @click="download(item.FileId, item.Remark, item.QualificationName)">{{ item.QualificationName }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: 'first',
      formInline: {},
      fileList1: [],
      fileList2: [],
      fileList3: [],
      fileList4: [],
      type: ''
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    back() {
      this.$router.push('/MemberCenter')
    },
    getList() {
      this.postRequest('SupplierLogin/SupplierDetail', {}).then((res) => {
        if (res.data.errcode == 0) {
          this.formInline = res.data.data
          let FileList = this.formInline.FileList
          this.fileList1 = FileList.filter((item) => {
            return item.FileType == 1
          })
          this.fileList2 = FileList.filter((item) => {
            return item.FileType == 2
          })
          this.fileList3 = FileList.filter((item) => {
            return item.FileType == 3
          })
          this.fileList4 = FileList.filter((item) => {
            return item.FileType == 4
          })
        } else {
          this.$message.error(res.data.errmsg)
        }
      })
    },
    download(FileId, remark, fileName) {
      let token = window.localStorage.getItem('loginToken')
      token = token.replace(/\+/g, '%2B')
      var url = 'SupplierLogin/DownLoadFile?fileId=' + FileId + '&remark=' + remark + '&token=' + token + '&fileName=' + fileName
      console.log(this.baseURL + url)
      this.downloadfile(this.baseURL + url)
    }
  }
}
</script>
<style lang="scss" scoped>
.EnterpriseInform {
  .content_wrap {
    padding-top: 15px;
    padding-bottom: 50px;
    margin-bottom: 20px;
  }

  ::v-deep .el-tabs__content {
    padding: 0;
  }

  ::v-deep .el-tabs__header {
    margin-bottom: 5px;
  }

  ::v-deep .el-form {
    margin: 0 15px 5px;

    .el-form-item__content {
      justify-content: left;
    }
  }

  .title {
    height: 50px;
    line-height: 50px;
    border: none;
  }

  .record_table {
    margin-top: 0;
  }

  .link {
    cursor: pointer;
  }
}

.back_btn {
  height: 26px;
  bottom: 7px;
  padding: 0 18px;
  border-radius: 14px;
}

.wrap_style ::v-deep .el-form-item__content {
  display: block !important;
}

.filelist {
  margin-bottom: 10px;
}
</style>